import URL from 'url-parse';
import "../helper/explorer_support";

let defaultServletPath = "/accounting";
let defterControlServletPath = "/defter-control";

let url = new URL(window.location.href);
let servletPath = "";

if (url.port === "3000" || url.pathname.startsWith(defaultServletPath))
  servletPath = defaultServletPath;

let reactPath;
if (url.pathname.startsWith(defaultServletPath))
  reactPath = defaultServletPath;
else
  reactPath = "/";
console.log(servletPath);
export const REACT_PATH = reactPath;
export const SERVLET_PATH = servletPath;
export const API_BASE_URL = servletPath + "/api";
export const DEFTER_CONTROL_API_BASE_URL = defterControlServletPath + "/api";
export const ACCESS_TOKEN = "accessToken";
export const KEEP_SESSION_OPEN = "false";
console.log(DEFTER_CONTROL_API_BASE_URL);
export let VirtualHost = {};
export let EntegratorConf = {};